// extracted by mini-css-extract-plugin
module.exports = {"list":"Menu_list__1V5e6","item":"Menu_item__ebvmz","itemActive":"Menu_itemActive__1QZhW"};